<template>
    <div class="container">
        <vue-headful
                title="Stories - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3>Success Stories</h3>
                            </div>
                            <div class="col text-md-right">
                                <router-link :to="{name: 'website-stories-add'}" class="btn my-4 btn-primary">
                                    ADD Stories
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">User ID</th>
                                <th scope="col">User Type</th>
                                <th scope="col">Stories</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="story in StoriesDetails" :key="story.id">
                                <td>
                                    <button @click="deleteStory(story.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Success Story"></button>
                                    <router-link :to="{name: 'website-stories-update', params: { story_id: story.id }}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Success Story"></router-link>
                                </td>
                                <td scope="row">
                                    <strong>{{story.user_id}}</strong>
                                </td>
                                <td v-html="getUserType(story.user_type)">
                                <td v-html="story.short_text">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      StoriesDetails: {}
    };
  },
  methods: {
    wip: function() {
      alert("Work in progress");
    },
    goNew: function() {
      window.location.href = "/dashboard/website/stories/new";
    },
    get_Stories() {
      axios({
        url:
          "admin/success-stories/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.StoriesDetails = result.data.success_stories;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteStory(id) {
      axios({
        method: "delete",
        url:
          "admin/success-stories/delete/" +
          id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Story Deleted Successfully", "", "success");
            this.get_Stories();
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    getUserType(type) {
      if (type == "1") {
        return "<span class='text-success'>Student</span>";
      } else if (type == "2") {
        return "<span class='text-info'>Company</span>";
      } else {
        return "<span class='text-primary'>Employee</span>";
      }
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Stories();
  }
};
</script>
<style>
</style>
